// Throws while the pointer is locked (HammerPot); touches keep their implicit capture.
export function capturePointer(element, pointerId) {
    try { element.setPointerCapture(pointerId); } catch {}
}
